const EMBEDDABLE = /google\.[^/]+\/maps\/embed|output=embed/i;
const SHARE_LINK = /maps\.app\.goo\.gl|goo\.gl\/maps/i;

/** Share links (maps.app.goo.gl) cannot be iframed; use address search embed instead. */
export function googleMapsEmbedSrc(mapLink?: string, queryFallback?: string): string | null {
  const link = String(mapLink || '').trim();
  if (link && EMBEDDABLE.test(link) && !SHARE_LINK.test(link)) return link;

  const query = String(queryFallback || '').trim();
  if (!query) return null;
  return `https://www.google.com/maps?output=embed&q=${encodeURIComponent(query)}`;
}
